import { render, staticRenderFns } from "./title-table-goal-setting.component.vue?vue&type=template&id=130e6e0c&scoped=true"
import script from "./title-table-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./title-table-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./title-table-goal-setting.component.vue?vue&type=style&index=0&id=130e6e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e6e0c",
  null
  
)

export default component.exports